import React from 'react';
import './index.css';
import { FileCrossIcon } from '../../assets/icons/file-cross';
import { Col, Row } from 'antd';
import { EmptyBankIcon } from 'assets/icons/empty-bank-details';
import { SuccessButton } from 'components/button';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';

export const EmptyBankDetails: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return (<div>
        <Row gutter={16} style={isMobile ? { textAlign: 'center', justifyContent: 'space-around' } : { alignItems: 'baseline' }}>
            <Col><EmptyBankIcon /></Col>
            <Col>
                <p className='font18'>No bank details found.</p>
                <span style={{ color: '#999999',fontSize:'16px' }}>Kindly complete your customer’s profile to setup auto-pay mandate.</span>
                <br />
                <SuccessButton onClick={() => history.push('/profile/kyc-details?flowType=checkout')} style={{ marginTop: '16px', width: '187px' }}>Complete Profile</SuccessButton>
            </Col>
        </Row>
    </div>)
}

export const EmptyActiveMandates: React.FC = () => {
    return (<div className="emptyActiveMandateContainer">
        <FileCrossIcon />
        <h3>No Active Mandates</h3>
        <p>You have zero active mandates.</p>
    </div>
    )
}

export default EmptyActiveMandates